import InfoIcon from "@mui/icons-material/Info";
import * as MUI from "@mui/material";
import { useState } from "react";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { IoWarningOutline } from "react-icons/io5";
import { VscError } from "react-icons/vsc";
import ConfirmAndCancelButtons from "../components/buttons/ConfirmAndCancelButtons";
import { CRIMSON_RED } from "../enums/Colors";
import usePrimaryColor from "./usePrimaryColor";

const useConfirm = (title, confirmMessage, cancelMessage, alert) => {
  const [promise, setPromise] = useState(null);
  const [message, setMessage] = useState("");
  const [subTitle, setSubTitle] = useState();
  const [alertType, setAlertType] = useState("info");
  const [confirmationSize, setConfirmationSize] = useState("xs");
  const confirm = () =>
    new Promise((resolve, reject) => {
      setPromise({ resolve });
    });

  const handleClose = () => {
    setPromise(null);
  };
  function getAlertType(input_type) {
    setAlertType(input_type);
  }
  function getSubtitle(input_subtitle) {
    setSubTitle(input_subtitle);
  }
  function getMessage(input_message) {
    setMessage(input_message);
  }
  const handleConfirm = () => {
    promise?.resolve(true);
    handleClose();
  };

  const handleCancel = () => {
    promise?.resolve(false);
    handleClose();
  };

  const color = usePrimaryColor();

  const handleSetConfirmationSize = (size) => {
    setConfirmationSize(size);
  };

  function infoLogo() {
    if (alert == "info") {
      return <InfoIcon className="Mui-confirmation-dialog-icon" />;
    } else if (alert == "error") {
      return <VscError color={CRIMSON_RED} size={120} />;
    } else if (alert == "warning") {
      return <IoWarningOutline color={"orange"} size={120}/>
    }
    return <IoMdInformationCircleOutline color={color} size={120} />;
  }

  const ConfirmationDialog = () => (
    <MUI.Dialog
      open={promise !== null}
      fullWidth
      maxWidth={confirmationSize}
      PaperProps={{ sx: { borderRadius: "18px" } }}
    >
      <MUI.Stack p={2} justifyContent={"center"} alignItems={"center"}>
        {infoLogo()}
      </MUI.Stack>
      <MUI.DialogContent sx={{ textAlign: "center" }}>
        {message}
      </MUI.DialogContent>
      <MUI.Divider />
      <MUI.DialogActions sx={{ p: 2 }}>
        <ConfirmAndCancelButtons
        confirmTitle={confirmMessage}
        cancelTitle={cancelMessage}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        confirmButtonType="submit"
        testId="shared.confirm-dialog"
        />
      </MUI.DialogActions>
    </MUI.Dialog>
  );
  return {
    ConfirmationDialog,
    confirm,
    getMessage,
    getSubtitle,
    getAlertType,
    handleSetConfirmationSize,
  };
};

export default useConfirm;
